import { createSelector } from 'reselect'

const getSystem = state => state.system;

export const isSignUpAvailable = createSelector(
    [getSystem],
    (system) => {
        return true;
    }
);
export const isPurchaseAvailable = createSelector(
    [getSystem],
    (system) => {
        return true;
    }
);
export const isPasswordRestoreAvailable = createSelector(
    [getSystem],
    (system) => {
        return true;
    }
);
